import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { Categoria, Item, Blobs, Iva, Um, BlobService, ItemsService, IvaService, UmService } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-items-edit',
  templateUrl: './items-edit.component.html',
  styleUrls: ['./items-edit.component.css']
})
export class ItemsEditComponent implements OnInit {
  id: string;
  item: Item;
  ums: Observable<Um[]>;
  ives: Observable<Iva[]>;
  categorie: Observable<Categoria[]>;
  images: Observable<Blobs[]>;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private itemsservice: ItemsService,
    private categorieservice: CategorieService,
    private ivaservice: IvaService,
    private imagesservice: BlobService,
    private umservice: UmService
  ) { }
  onSubmit() {
    if (!this.item.image_id) {
this.item.image_id = null;
    }
    this.itemsservice.update(this.item).then(() => {
this.router.navigate(['/items', 'details', this.id]);
});
  }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.itemsservice.details(this.id).subscribe(m => {
      this.item = m;
      this.item.iva_id = m.iva_id;

      return this.item;
    });
    this.ums = this.umservice.list();
    this.ives = this.ivaservice.list();
    this.categorie = this.categorieservice.list();
    this.images = this.imagesservice.getimages();
  }

}
